import CompanyEmailTab from './CompanyEmailTab';
import { DialogUI } from '../Interface';

const CompanyEmailDialog = ({ disabled, documentTypes, onClose, open, selectedValues, valuesState }) => {
  return (
    <DialogUI
      open={open}
      onClose={onClose}
      headerContent="E-mail címzettek"
      maxWidth="md"
      fullWidth
      closeBtn
    >
      <CompanyEmailTab
        disabled={disabled}
        documentTypes={documentTypes}
        selectedValues={selectedValues}
        valuesState={valuesState}
      />
    </DialogUI>
  );
};

export default CompanyEmailDialog;
